export default __webpack_public_path__ + "static/media/dumpster-large.a7b4850c.svg";